import React, { useEffect, useRef } from "react";
import Section1 from "../../components/section1/index";
import Assignmenthelp from "../../components/assignmenthelp/assignmenthelp";
import CarouselComponent from "../../components/assignmentTypes/assignmentTypes";
import Bestquality from "../../components/bestQuality/Bestquality";
import FaqSection from "../../components/faqs/Faqs";
import FeedbackCarousel from "../../components/feedbacks/Feedbacks";
import Writingtools from "../../components/writingtools/Writingtools";
import ChatBot from "../../components/chatbot/Chatbot";
import Section2 from "../../components/section2/index";
import WhatsAppChat from "../../components/whatsAppChat/WhatsApp";

const ServicesSingle = () => {
  const section2Ref = useRef(null);
  const feedbackRef = useRef(null);
  const faqsRef = useRef(null);
  const footerSubsRef = useRef(null);



  // Store reference in localStorage for Footer to access
  useEffect(() => {
    window.section2Ref = section2Ref;
    window.feedbackRef = feedbackRef;
    window.faqsRef = faqsRef;
    window.footerSubsRef = footerSubsRef;

  }, []);

  return (
    <>
      <div ref={footerSubsRef}>
        <Section1 />
      </div>
      <div ref={section2Ref}>
        <Section2 />
      </div>
      <Assignmenthelp />
      <CarouselComponent />
      <Bestquality />
      {/* <Writingtools /> */}
      <div ref={feedbackRef}>
        <FeedbackCarousel />
      </div>
      <div ref={faqsRef}>
        <FaqSection />
      </div>
      
    </>
  );
};

export default ServicesSingle;
